import "../style.css";
import React from 'react';
import PanelContent from "../components/PanelContent"

export default function EnergyFlow() {
  return (
    <PanelContent 
        id="energy_pannel"
        route="/energyflow"
        title="Distribution de l’énergie"
        subtitle="Alimentation électrique"
        description="La première étape de ce test à grande échelle consiste à fournir l'alimentation électrique au démonstrateur. Pour cela, un poste électrique central achemine le courant vers une sous-station composée de deux bâtiments. Cette sous-station a pour rôle de convertir le courant et de le redistribuer le long de la voie de test. À ce stade, le courant n'est pas encore utilisé par la piste ERS intégrée dans la chaussée."
        prev="/about"
        next="/smartpowering"
        txtbtn="ÉTAPE SUIVANTE"
    />
  );
}


